import { render, staticRenderFns } from "./Tab52Table.vue?vue&type=template&id=908ed5b2"
import script from "./Tab52Table.vue?vue&type=script&lang=js"
export * from "./Tab52Table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports